export const API_VERSION = 'v1.9';
export const BACKOFFICE_PREFIX = `/backoffice/${API_VERSION}`;
